import AlephBet from "alephbet"
import {storageAdapter, lamedAdapter} from "./adapters"
import {notLoggedIn} from "./helpers"
import {registeredSuccessfully} from "./goals"
import $ from "cash-dom"

export default () => {
  const trustCopyOnHeaderV2 = new AlephBet.Experiment({
    name: "202507 Trust copy on header v2",
    /* eslint-disable camelcase */
    tracking_adapter: lamedAdapter,
    storage_adapter: storageAdapter,
    /* eslint-enable camelcase */
    trigger: () => (notLoggedIn()),
    variants: {
      "1-Original": {
        activate: () => {
        }
      },
      "2-Variant": {
        activate: (experiment) => {
          if (!experiment.options.trigger()) return
          const heroSubsection = $(".l-hero--subsection")
          if (!heroSubsection.length) return

          $("body").addClass("ab-test-trust-copy-on-header")
          heroSubsection.remove()
          $(".l-navigation__tagline").remove()
        }
      }
    }
  })

  trustCopyOnHeaderV2.add_goals([
    registeredSuccessfully
  ])
}
